// extracted by mini-css-extract-plugin
export default {"code":"Code_code__oMsQn","absolute":"Code_absolute__S58+k","copied":"Code_copied__L50p-"};